const API_URL = {
  thisisneverthat: "https://nuokj6brrzhtqzxwkagibafqkm0yvqzv.lambda-url.ap-northeast-2.on.aws/",
  yeseyesee: "https://vb4yl4tnkq3qhjp36jewpbkgr40xsdlt.lambda-url.ap-northeast-2.on.aws/",
  khakis: "https://dskkokzej7lga32y6dbqpq3p2q0ctsgf.lambda-url.ap-northeast-2.on.aws/",
  sunlove: "https://umailz2icwkhwvidpjfyso33cu0cctaa.lambda-url.ap-northeast-2.on.aws/",
  wellbeingexpress: "https://qlj6l45uth3puvpksjvsm4fp5y0qjsik.lambda-url.ap-northeast-2.on.aws/",
};

interface ICancelOrder {
  status: number;
}

export const cancelOrder = async ({
  shop,
  domain = "",
  customerId,
  orderId,
}: {
  shop: string;
  domain?: "ko" | "en" | "jp" | "";
  customerId: string;
  orderId: string;
}): Promise<ICancelOrder | undefined> => {
  const lambdaUrl = API_URL[shop as keyof typeof API_URL];
  if (!lambdaUrl) return;

  try {
    const url = `${lambdaUrl}?customer_id=${customerId}&order_id=${orderId}&domain=${domain}`;
    const response = await fetch(url).then((res) => res);
    if (response.status === 200) {
      return response as ICancelOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
